<template>
  <page>
    <!-- <template slot="header"> 
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6">
            <h3 class="m-0 text-dark">
              Ordens de Serviço Reabertas
            </h3>
          </div>
          <div class="col-sm-6">
            <b-breadcrumb
              class="float-sm-right"
              :items="breadcrumbItems"
            ></b-breadcrumb>
          </div>
        </div>
      </div>
    </template> -->

    <template slot='content'>
      <!-- <indicadores-resumo v-if="mecanico"></indicadores-resumo> -->

      <!-- <Hr /> -->

      <os-reabertas-component></os-reabertas-component>
      <reloadPage></reloadPage>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import OsReabertasComponent from '@/components/OsReabertasComponent.vue'
import reloadPage from '../common/reloadPage.vue';

export default {
  components: {
    Page,
    OsReabertasComponent,
    reloadPage
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  created () {    
  },

  computed:{
    mecanico() {
      let mecanicoOs = JSON.parse(localStorage.filial);
      if (mecanicoOs.atendeOs == 'S') {
        return false
      } else {
        return true
      }
    }
  },

  data () {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: 'Ordens de Serviço',
          active: true
        }
      ],
      timer: ''
    }
  },
  methods: {

  }
}
</script>
